module.exports = __webpack_public_path__ + "static/img/RWA1266-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWA1266-G_1.png
// module id = +DxP
// module chunks = 0